/* eslint-disable no-underscore-dangle */

import { initialize } from 'redux-form';
import { FORM_NAME } from '../Form';
import { getProps } from '../props';


export default () => async (dispatch, getState) => {

  const { estimate } = getProps();

  const { reference, project, title, user } = estimate;

  const referencePrefix = estimate.reference_prefix;
  const referenceSuffix = estimate.reference_suffix;
  const contact = estimate.client_contact;

  // Get default CC email from user settings for estimates
  const state = getState();
  const userSettings = (state.core && state.core.userSettings) || {};
  const defaultCcEmail = userSettings.email_default_cc_estimate;

  // Parse comma-separated emails into array
  const defaultCcEmails = defaultCcEmail
    ? defaultCcEmail.split(',').map(e => e.trim()).filter(e => e.length > 0)
    : [];

  const values = {
    to: [],
    cc: defaultCcEmails,
    bcc: [],
    subject: `Estimate - [${referencePrefix} ${reference}${referenceSuffix ? ` / ${ referenceSuffix }` : ''}] ${project.client_site.name} ${title || ''}`,
    body: '',
    id: estimate.id,
    include_attachments: true,
  };

  if (contact.email) values.to.push(contact.email);

  // DEBUG: Log final values before dispatch
  console.log('[EmailEstimate Debug] Final values.cc:', values.cc);
  console.log('[EmailEstimate Debug] Full values object:', values);

  values.body += `Dear ${estimate.client_contact.first_name}\r\n\r\n`;
  values.body += `Thank you for your enquiry\r\n\r\n`;
  values.body += `Please find attached our estimate for the ${project.client_site.name} project. Please review the estimate and if you require any additional information, please do not hesitate to contact me.\r\n\r\n`;
  values.body += `I look forward to hearing from you.\r\n\r\n`;
  values.body += `Kind Regards\r\n\r\n`;

  if (user) {

    values.body += `${user.first_name} ${user.last_name}`;

  }


  dispatch(initialize(FORM_NAME, values));

}
